import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import promiseMiddleware from './../middleware/promise-middleware';
import { persistConfig, Reducer } from './../reducers/index';
var reduxLogger = createLogger({
    collapsed: true,
    stateTransformer: function (state) {
        return state;
    }
});
var persistedReducer = persistReducer(persistConfig, Reducer);
function configuredStore() {
    var _store = configureStore({
        reducer: persistedReducer,
        middleware: function (getDefaultMiddleware) {
            var middleware = getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: false,
            }).concat(promiseMiddleware, thunk);
            if (__DEV__) {
                return middleware.concat(reduxLogger);
            }
            return middleware;
        }
    });
    _enableHotLoader(_store);
    return _store;
}
function _enableHotLoader(_store) {
    if (!__DEV__) {
        return;
    }
    var hot = module.hot;
    if (hot) {
        hot.accept('./../reducers', function () {
            var nextRootReducer = require('./../reducers');
            _store.replaceReducer(nextRootReducer);
        });
    }
}
export var store = configuredStore();
export var persistor = persistStore(store);
store.subscribe(function () {
    try {
        var storeSize = (JSON.stringify(store.getState()).length / 1000000);
        if (storeSize > 4) {
            alert('Low offline storage space. Please go online to free space.');
        }
    }
    catch (e) {
        alert('Very low offline storage space. Please go online to free space.');
    }
});
